import React from 'react';
import { Link } from 'react-router-dom';

const TermsAndConditions = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <Link to="/" className="legal-back">&larr; Volver al inicio</Link>
        <h1 className="legal-title">T&eacute;rminos y Condiciones</h1>
        <p className="legal-date">
          <em>&Uacute;ltima actualizaci&oacute;n: {new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })}</em>
        </p>

        <section className="legal-section">
          <h2>1. Identificaci&oacute;n del prestador</h2>
          <p>
            El presente sitio web es titularidad de:
          </p>
          <ul>
            <li><strong>Titular:</strong> Myntar S.L. PENDIENTE NIF</li>
            <li><strong>NIF/CIF:</strong> PENDIENTE</li>
            <li><strong>Domicilio:</strong> Calle Lorenzo Ferreira 26, C&oacute;rdoba, Espa&ntilde;a</li>
            <li><strong>Email:</strong> contact@myntar.tech</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>2. Objeto y &aacute;mbito de aplicaci&oacute;n</h2>
          <p>
            Los presentes T&eacute;rminos y Condiciones regulan el acceso y uso del sitio web
            www.myntar.tech (en adelante, &ldquo;el Sitio Web&rdquo;), propiedad de Myntar.
          </p>
          <p>
            El acceso al Sitio Web implica la aceptaci&oacute;n sin reservas de los presentes
            T&eacute;rminos y Condiciones. Si no est&aacute; de acuerdo con alguna de las condiciones
            aqu&iacute; establecidas, le rogamos que no utilice este Sitio Web.
          </p>
          <p>
            Estos T&eacute;rminos y Condiciones se aplican al sitio web informativo y de contacto
            de Myntar. La contrataci&oacute;n de servicios espec&iacute;ficos de Myntar se regir&aacute;
            por condiciones particulares que ser&aacute;n comunicadas al cliente en cada caso.
          </p>
        </section>

        <section className="legal-section">
          <h2>3. Acceso y uso del sitio web</h2>
          <p>
            El acceso al Sitio Web es gratuito y no requiere registro previo. El usuario se compromete
            a utilizar el Sitio Web de conformidad con la ley, los presentes T&eacute;rminos y Condiciones,
            la moral y las buenas costumbres generalmente aceptadas, y el orden p&uacute;blico.
          </p>
          <p>El usuario se compromete a:</p>
          <ul>
            <li>No utilizar el Sitio Web con fines il&iacute;citos o no autorizados</li>
            <li>No interferir ni interrumpir el funcionamiento del Sitio Web o los servidores
            conectados al mismo</li>
            <li>No intentar acceder a &aacute;reas restringidas del Sitio Web sin autorizaci&oacute;n</li>
            <li>No introducir virus, troyanos u otro software malicioso</li>
            <li>No utilizar robots, spiders u otros mecanismos autom&aacute;ticos para acceder al
            contenido del Sitio Web sin autorizaci&oacute;n</li>
            <li>Proporcionar informaci&oacute;n veraz y actualizada en los formularios del Sitio Web</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>4. Servicios ofrecidos</h2>
          <p>
            A trav&eacute;s de este Sitio Web, Myntar ofrece informaci&oacute;n sobre sus productos y
            servicios de inteligencia artificial conversacional, incluyendo:
          </p>
          <ul>
            <li>Informaci&oacute;n sobre la plataforma de avatares inteligentes</li>
            <li>Descripci&oacute;n de casos de uso y sectores de aplicaci&oacute;n</li>
            <li>Formulario de contacto para solicitar informaci&oacute;n o demostraciones</li>
            <li>Informaci&oacute;n corporativa sobre la empresa y su equipo</li>
          </ul>
          <p>
            Myntar se reserva el derecho de modificar, suspender o interrumpir, de forma temporal o
            permanente, la prestaci&oacute;n de cualquiera de los servicios del Sitio Web, con o sin
            previo aviso, sin que ello genere derecho a indemnizaci&oacute;n alguna.
          </p>
        </section>

        <section className="legal-section">
          <h2>5. Propiedad intelectual e industrial</h2>
          <p>
            Todos los contenidos del Sitio Web, incluyendo textos, im&aacute;genes, dise&ntilde;os
            gr&aacute;ficos, logotipos, iconos, v&iacute;deos, software, c&oacute;digo fuente y
            cualquier otro material, est&aacute;n protegidos por derechos de propiedad intelectual
            e industrial y son titularidad de Myntar o de terceros que han autorizado su uso.
          </p>
          <p>
            La marca &ldquo;Myntar&rdquo;, as&iacute; como todos los logotipos y signos distintivos
            que aparecen en el Sitio Web, son marcas registradas o en proceso de registro, propiedad
            de Myntar. Su uso no autorizado constituye una infracci&oacute;n de los derechos de
            propiedad industrial.
          </p>
          <p>
            Queda prohibida, salvo autorizaci&oacute;n expresa y por escrito de Myntar:
          </p>
          <ul>
            <li>La reproducci&oacute;n, distribuci&oacute;n o comunicaci&oacute;n p&uacute;blica
            de los contenidos del Sitio Web</li>
            <li>La modificaci&oacute;n, transformaci&oacute;n o descompilaci&oacute;n del software</li>
            <li>El uso de los contenidos con fines comerciales sin autorizaci&oacute;n previa</li>
            <li>La extracci&oacute;n sistem&aacute;tica de datos del Sitio Web</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>6. Limitaci&oacute;n de responsabilidad</h2>
          <p>
            Myntar no garantiza la disponibilidad continua e ininterrumpida del Sitio Web.
            Myntar no ser&aacute; responsable de:
          </p>
          <ul>
            <li>Da&ntilde;os derivados de interrupciones del servicio, fallos inform&aacute;ticos,
            averias telef&oacute;nicas, desconexiones o retrasos causados por causas ajenas a su control</li>
            <li>Da&ntilde;os causados por terceros mediante intromisiones ileg&iacute;timas fuera del
            control de Myntar</li>
            <li>Errores u omisiones en los contenidos del Sitio Web, aunque se esforzar&aacute; por
            mantenerlos actualizados y precisos</li>
            <li>El uso que los usuarios hagan de los contenidos e informaci&oacute;n obtenidos a
            trav&eacute;s del Sitio Web</li>
            <li>Los da&ntilde;os o perjuicios que se produzcan por causas de fuerza mayor o caso fortuito</li>
          </ul>
          <p>
            La informaci&oacute;n contenida en este Sitio Web tiene car&aacute;cter general e
            informativo y no constituye, en ning&uacute;n caso, asesoramiento profesional de ning&uacute;n tipo.
          </p>
        </section>

        <section className="legal-section">
          <h2>7. Enlaces a terceros</h2>
          <p>
            El Sitio Web puede contener enlaces a sitios web de terceros. Estos enlaces se proporcionan
            &uacute;nicamente como referencia y no implican que Myntar apruebe, respalde o recomiende
            el contenido de dichos sitios.
          </p>
          <p>
            Myntar no se hace responsable del contenido, pol&iacute;ticas de privacidad, condiciones
            de uso o pr&aacute;cticas de los sitios web de terceros. El usuario accede a dichos sitios
            bajo su propia responsabilidad.
          </p>
        </section>

        <section className="legal-section">
          <h2>8. Formulario de contacto</h2>
          <p>
            El Sitio Web pone a disposici&oacute;n del usuario un formulario de contacto para solicitar
            informaci&oacute;n sobre los servicios de Myntar. El env&iacute;o del formulario implica:
          </p>
          <ul>
            <li>La aceptaci&oacute;n de la <Link to="/privacidad">Pol&iacute;tica de Privacidad</Link></li>
            <li>El consentimiento para el tratamiento de los datos personales facilitados</li>
            <li>La veracidad de los datos proporcionados, siendo el usuario responsable de cualquier
            da&ntilde;o directo o indirecto que pudiera causar por la cumplimentaci&oacute;n de datos
            falsos o inexactos</li>
          </ul>
          <p>
            Myntar se compromete a responder a las consultas recibidas en un plazo razonable,
            sin que ello suponga ninguna obligaci&oacute;n contractual.
          </p>
        </section>

        <section className="legal-section">
          <h2>9. Avatar Interactivo - Condiciones de Uso</h2>
          <p>
            El Sitio Web incluye un avatar interactivo con inteligencia artificial para demostraci&oacute;n
            de nuestros servicios. El uso del avatar est&aacute; sujeto a las siguientes condiciones:
          </p>
          <ul>
            <li><strong>Finalidad demostrativa:</strong> El avatar se proporciona exclusivamente con
            fines informativos y de demostraci&oacute;n. No constituye asesoramiento profesional de ning&uacute;n tipo.</li>
            <li><strong>Informaci&oacute;n sobre datos:</strong> El uso del avatar implica el procesamiento
            de datos t&eacute;cnicos bajo inter&eacute;s leg&iacute;timo (Art. 6.1.f RGPD). El usuario puede
            consultar los detalles en la <Link to="/privacidad">Pol&iacute;tica de Privacidad</Link>.</li>
            <li><strong>Uso responsable:</strong> El usuario se compromete a no utilizar el avatar para
            transmitir contenido ofensivo, ilegal o inapropiado.</li>
            <li><strong>Limitaciones t&eacute;cnicas:</strong> Myntar no garantiza la disponibilidad continua
            del avatar ni la exactitud del 100% de las respuestas generadas.</li>
            <li><strong>Menores de edad:</strong> El uso del avatar por menores de 14 a&ntilde;os requiere
            consentimiento de los padres o tutores legales.</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>10. Protecci&oacute;n de datos</h2>
          <p>
            El tratamiento de datos personales se rige por nuestra <Link to="/privacidad">Pol&iacute;tica
            de Privacidad</Link>, que forma parte integrante de estos T&eacute;rminos y Condiciones.
            Le recomendamos leerla detenidamente.
          </p>
        </section>

        <section className="legal-section">
          <h2>11. Modificaciones</h2>
          <p>
            Myntar se reserva el derecho de modificar los presentes T&eacute;rminos y Condiciones
            en cualquier momento. Las modificaciones entrar&aacute;n en vigor desde el momento de su
            publicaci&oacute;n en el Sitio Web. El uso continuado del Sitio Web tras la publicaci&oacute;n
            de las modificaciones implicar&aacute; la aceptaci&oacute;n de los nuevos T&eacute;rminos
            y Condiciones.
          </p>
          <p>
            Se recomienda al usuario revisar peri&oacute;dicamente estos T&eacute;rminos y Condiciones.
          </p>
        </section>

        <section className="legal-section">
          <h2>12. Nulidad parcial</h2>
          <p>
            Si alguna de las cl&aacute;usulas de los presentes T&eacute;rminos y Condiciones fuera
            declarada nula o inaplicable, dicha cl&aacute;usula ser&aacute; excluida sin afectar a
            la validez del resto de cl&aacute;usulas, que mantendr&aacute;n su plena vigencia y efecto.
          </p>
        </section>

        <section className="legal-section">
          <h2>13. Legislaci&oacute;n aplicable y jurisdicci&oacute;n</h2>
          <p>
            Los presentes T&eacute;rminos y Condiciones se rigen por la legislaci&oacute;n espa&ntilde;ola.
            Para la resoluci&oacute;n de cualquier controversia derivada del acceso o uso de este Sitio
            Web, las partes se someten a los Juzgados y Tribunales de C&oacute;rdoba (Espa&ntilde;a),
            con renuncia expresa a cualquier otro fuero que pudiera corresponderles, salvo que la
            legislaci&oacute;n aplicable disponga otra cosa.
          </p>
        </section>

        <section className="legal-section">
          <h2>14. Contacto</h2>
          <p>
            Para cualquier consulta sobre estos T&eacute;rminos y Condiciones, puede contactarnos en:
          </p>
          <p>
            <strong>Email:</strong> contact@myntar.tech<br />
            <strong>Direcci&oacute;n:</strong> C&oacute;rdoba, Espa&ntilde;a
          </p>
        </section>

        <div className="legal-links-section">
          <p>Ver tambi&eacute;n:</p>
          <ul>
            <li><Link to="/aviso-legal">Aviso Legal</Link></li>
            <li><Link to="/privacidad">Pol&iacute;tica de Privacidad</Link></li>
            <li><Link to="/cookies">Pol&iacute;tica de Cookies</Link></li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
